//CSS
import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

const Advantages: React.FC = () => {
  return (
    <div id="Goals" className="sectionContainer">
      <SecHeader title="ELF-Tech™ Advantages" />
      <SubSection isSplit={false}>
        <div className="description-container">
          <p>
            <ul>
              <li>50% the size and weight for the same power rating​</li>
              <li>Mechanical variable compression (from 5:1 to 60:1)​​</li>
              <li>Independently variable compression and expansion​​</li>
              <li>Up to 150% of break (shaft) efficiency​​</li>
              <li>Lower emissions of all types up to 50% better​​</li>
              <li>Lower production costs and 70% the costs to run​​</li>
              <li>Better balance, less vibration, quieter operations​​</li>
              <li>Versions using different and even multiple fuels​​</li>
              <li>Fewer parts, fewer failure points, and longer life​</li>
            </ul>
          </p>
        </div>
      </SubSection>


    </div>
  );
};

export default Advantages;